import { Command } from 'commander';
import ora from 'ora';
import { WorkflowManager } from '../core/workflow-manager';
import { logger } from '../utils/logger';
import { setupWatchMode } from '../utils/watch-helper';
import { withErrorHandling } from '../utils/error-handler';

export function createSyncCommand(): Command {
  const command = new Command('sync');

  command
    .description('Sync tasks from project TODO files')
    .option('-w, --watch', 'Watch for changes and auto-sync')
    .option('-i, --interval <ms>', 'Sync interval in milliseconds (default: 300000)', '300000')
    .action(withErrorHandling(async (options) => {
      const manager = new WorkflowManager();

      if (options.watch) {
        await setupWatchMode(manager, 'task sync watcher');
      } else {
          const spinner = ora('Syncing tasks...').start();
          
          try {
            await manager.syncTasks();
            const result = await manager.analyzeTasks();
            
            spinner.succeed(`Synced ${result.statistics.total} tasks`);
            
            logger.info('');
            logger.info(`📊 Task Statistics:`);
            logger.info(`  Total: ${result.statistics.total}`);
            logger.info(`  Completed: ${result.statistics.completed} (${result.statistics.completionRate}%)`);
            logger.info(`  In Progress: ${result.statistics.inProgress}`);
            logger.info(`  Pending: ${result.statistics.pending}`);
            
            if (result.recommendations.length > 0) {
              logger.info('');
              logger.info('💡 Recommendations:');
              result.recommendations.forEach(rec => {
                logger.info(`  - ${rec.title}`);
              });
            }
          } catch (error) {
            spinner.fail('Failed to sync tasks');
            throw error;
          }
        }
    }));

  return command;
}